import React from 'react';
import colors from 'styles/colors';
import classNames from 'classnames';
import { transparentize } from 'polished';
import makeStyles from '@material-ui/core/styles/makeStyles';
import typography from 'styles/typography';

import Radio from '@material-ui/core/Radio';
import Card from '@material-ui/core/Card';
import { Typography } from '@material-ui/core';

import * as Types from 'pages/Directory/typings';

interface Props {
  sourceInfo: Types.SourceInfo;
  isSelected: boolean;
  isSourceAvailable?: boolean;
  handleSourceSelect: () => void;
}

function NewSourceCard({
  sourceInfo,
  isSelected,
  isSourceAvailable = true,
  handleSourceSelect,
}: Props) {
  const classes = useStyles();
  const { description, title, logo } = sourceInfo;

  return (
    <Card
      className={classNames(classes.card, !isSourceAvailable && classes.disabled)}
      onClick={handleSourceSelect}
    >
      <div className={classes.cardContent}>
        <div className={classes.checkDiv}>
          {isSourceAvailable ? (
            <Radio checked={isSelected} disabled={!isSourceAvailable} />
          ) : (
            <div className={classes.disabledIndicator}>Not Available</div>
          )}
        </div>
        <div className={classes.logo}>{logo}</div>
        <div className={classes.title}>{title}</div>
        <div className={classes.cardMid}>
          <Typography variant="body2" className={classes.description}>
            {description}
          </Typography>
        </div>
      </div>
    </Card>
  );
}

const useStyles = makeStyles(theme => {
  return {
    card: {
      cursor: 'pointer',
      minWidth: 250,
      minHeight: 400,
      display: 'inline-block',
      textAlign: 'center',
      marginTop: theme.spacing(2.875),
      marginRight: theme.spacing(3),
      marginBottom: 0,
    },
    cardContent: {
      flex: '1 1 auto',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      height: '100%',
    },
    checkDiv: {
      marginLeft: 'auto',
      alignSelf: 'flex-end',
      height: 42,
    },
    cardMid: {
      flex: '1 1 auto',
      display: 'flex',
    },
    description: {
      paddingLeft: theme.spacing(4.5),
      paddingRight: theme.spacing(4.5),
    },
    logo: {
      alignSelf: 'center',
    },
    title: {
      fontSize: typography.body1.fontSize,
      margin: theme.spacing(2, 0),
    },
    disabled: {
      pointerEvents: 'none',
    },
    disabledIndicator: {
      display: 'flex',
      justifyContent: 'center',
      borderRadius: theme.spacing(0.5),
      fontSize: typography.body2.fontSize,
      color: colors.info,
      backgroundColor: transparentize(0.9, colors.info),
      width: 99,
      height: 22,
      marginTop: theme.spacing(1.25),
      marginRight: theme.spacing(2),
    },
  };
});

export default NewSourceCard;
